import { BusinessObjectBase } from './base';
import type { Token } from './token';

export interface TokenHistoryData {
  readonly id: string;
  readonly eventType: string;
  readonly activityId?: string;
  readonly data?: any;
  readonly timestamp?: Date;
  readonly tokenId: number;
  readonly token?: Token;
}

export interface TokenHistory extends Readonly<TokenHistoryData> {}
export class TokenHistory extends BusinessObjectBase {
  static readonly entityName = 'TokenHistory' as const;
  static readonly plural = 'token-histories';

  // --- Static CRUD methods ---

  static async find(filter?: any): Promise<TokenHistory[]> {
    const url = `${this.baseUrl}/${this.plural}`;
    const params: Record<string, string> = {};
    if (filter) params['filter'] = JSON.stringify(filter);
    const results = await this.get<any[]>(url, params);
    return results.map((data) => new TokenHistory(data));
  }

  static async findOne(filter?: any): Promise<TokenHistory | null> {
    const url = `${this.baseUrl}/${this.plural}/find-one`;
    const params: Record<string, string> = {};
    if (filter) params['filter'] = JSON.stringify(filter);
    const data = await this.get<any>(url, params);
    return data ? new TokenHistory(data) : null;
  }

  static async findById(id: string, filter?: any): Promise<TokenHistory> {
    const url = `${this.baseUrl}/${this.plural}/${id}`;
    const params: Record<string, string> = {};
    if (filter) params['filter'] = JSON.stringify(filter);
    const data = await this.get<any>(url, params);
    return new TokenHistory(data);
  }

  static async create(
    data: Omit<TokenHistoryData, 'id'>,
  ): Promise<TokenHistory> {
    const url = `${this.baseUrl}/${this.plural}`;
    const result = await this.post<any>(url, data);
    return new TokenHistory(result);
  }

  static async updateById(
    id: string,
    data: Partial<TokenHistoryData>,
  ): Promise<TokenHistory> {
    const url = `${this.baseUrl}/${this.plural}/${id}`;
    const result = await this.patch<any>(url, data);
    return new TokenHistory(result);
  }

  static async deleteById(id: string): Promise<boolean> {
    const url = `${this.baseUrl}/${this.plural}/${id}`;
    try {
      await this.del<void>(url);
      return true;
    } catch {
      return false;
    }
  }
}
